<template>
  <a-layout class="verify-phone">
    <div class="verify-phone-content">
      <a-button type="default" class="go-back" @click="goBack">
        <a-icon type="left" />
        Regresar
      </a-button>

      <div class="content-base container">
        <a-row type="flex" justify="center">
          <a-col :md="10">
            <VerifyPhoneForm v-if="!isVerify" ref="verifyPhoneForm" />
            <a-card v-else class="verify-phone-form-card">
              <h2 class="description">
                El número de teléfono ya ha sido verificado.
              </h2>
            </a-card>
          </a-col>
        </a-row>
      </div>
    </div>
  </a-layout>
</template>

<script>
import loadingMixin from "@/mixins/loadingMixin";
import VerifyPhoneForm from "@/components/register/VerifyPhoneForm.vue";
import { mapActions } from "vuex";
export default {
  components: {
    VerifyPhoneForm,
  },
  mixins: [loadingMixin],
  data() {
    return {
      isVerify: false,
    };
  },
  methods: {
    ...mapActions("clientAuth", ["isVerifyPhone"]),
    async verifyPhone() {
      let { data: data } = await this.isVerifyPhone();

      this.isVerify = data.status === "success" ? true : false;

      const verifyPhone = this.$refs.verifyPhoneForm;
      if (verifyPhone) {
        const overlay = verifyPhone.$el.querySelector(".overlay");
        if (overlay) {
          overlay.style.display = "none";
        }
      }
    },
    goToEdit(id, link) {
      this.$router.push({ name: link });
      /* this.currentOption = this.options.find((opt) => opt.id === id);
      this.currentScreen = "edit"; */
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.verifyPhone();
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/variable";
.verify-phone {
  max-width: 100% !important;
  font-family: "Roboto", sans-serif;
  background-color: transparent;

  .verify-phone-content {
    padding: 10px;
    color: var(--white);

    .go-back {
      background: transparent !important;
      color: var(--btn-bg-primary);
      border-color: var(--btn-bg-primary);
      margin-bottom: 10px;
    }

    .content-base {
      padding: 0;
      max-width: 100%;
    }
  }
}
</style>
